import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { authService } from '../services/auth.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';
import type { ForgotPasswordData } from '../types/auth.types';

export function useForgotPassword() {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const mutation = useMutation({
    mutationFn: (data: ForgotPasswordData) => authService.forgotPassword(data),
    onSuccess: () => {
      setSuccess(true);
    },
    onError: (err: Error) => {
      console.error('[ForgotPassword] Error:', err);
      setError(getApiErrorMessage(err));
    },
  });

  const sendResetEmail = async (data: ForgotPasswordData) => {
    setError(null);
    setSuccess(false);
    return mutation.mutateAsync(data);
  };

  return {
    sendResetEmail,
    isLoading: mutation.isPending,
    error,
    success,
    clearError: () => setError(null),
    reset: () => {
      setError(null);
      setSuccess(false);
    },
  };
}
